<div class="referral-wrapper">
  <div *ngIf="inviteUser" class="referral-card">
    <h2>You've Been Invited!</h2>
    <div class="referral-info">
      <div class="text-start mb-1">
        <!-- <span class="label">User Name:</span> -->
        <p class="name">{{ inviteUser.owner_name }}</p>
      </div>
      <div class="d-flex justify-content-between align-items-center" style="padding-top:16px;border-top:1px solid #0f344333;">
        <div class="referral-code d-flex">
          <span class="label">Referral Code:</span>
          <span class="value">{{ inviteUser.code }}</span>
        </div>
        <button type="btn" class="btn copy-btn">Copy</button>
      </div>
      </div>
      <div style="margin-top: 1.5rem;background: #0f3443f5;padding: 29px;">
        <img
          [src]="inviteUser.qr_code"
          alt="Referral QR Code"
        />
        <div style="font-size: 20px; color: #888; margin-top:16px;line-height: 1.2;">
          Scan to use referral code
        </div>
      </div>
  </div>
</div>
